<template>
  <section v-if="$role.restricAccess($route.name, 'view')">
    <breadcrumb-template
      :headtitle="$route.meta.title"
      :breadcrumbcurrent="$route.meta.title"
    ></breadcrumb-template>
    <v-card class="card-outline force-remove-box">
      <v-card-text class="force-custom-bg">
        <v-container fluid>
          <v-row dense class="d-flex justify-end mt-n2">
            <!-- <v-col cols="12" lg="2" class="span-label">
              <span>Region</span>
              <v-select
                class="regular-field"
                dense
                clearable
                :items="region_list"
                item-value="id"
                item-text="region_name"
                label="Region"
                v-model="filter.region_id"
              >
              </v-select>
            </v-col> -->

            <v-col cols="12" lg="2" class="span-label">
              <span>Date</span>
              <v-text-field
                clearable
                dense
                hide-details
                class="regular-field"
                v-model="dt_filterDateFrom"
                label="Date to"
                type="date"
              ></v-text-field>
            </v-col>

            <v-col cols="12" lg="3" class="span-label">
              <span>Search any keyword</span>
              <v-text-field
                clearable
                dense
                class="regular-field"
                v-model="dt_searchQuery"
                label="Search"
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2" class="mt-7" style="padding-top:5px;">
              <v-btn
                color="green_button"
                class="float-right btn-block"
                @click="getDataFromApi()"
                >Search</v-btn
              >
            </v-col>
            <v-col cols="12" md="2" class="mt-7" style="padding-top:5px;">
              <downloadexcel
                class="float-right btn-block btn btn-secondary"
                :fields="json_fields"
                :fetch="exportData"
                name="Daily result.xls"
                type="csv"
              >
                <i class="fa fa-download"></i> Download Excel
              </downloadexcel>
            </v-col>

            <v-col cols="12" class="mt-2">
              <v-data-table
                class="custom-header-color table-bordered table-striped"
                :headers="dt_headers"
                :items="dt_resultlist"
                item-key="id"
                :loading="dt_loading"
                :options.sync="dt_options"
                :server-items-length="dt_totalResult"
              >
                <template v-slot:[`item.winners`]="{ item }">
                  <!-- <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"></v-avatar>  -->
                  {{ item.winners ? item.winners : 0 }}
                </template>

                <template v-slot:[`item.date`]="{ item }">{{
                  item.date | setDate
                }}</template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import downloadexcel from "vue-json-excel";
export default {
  components: {
    downloadexcel,
  },
  data() {
    return {
      schedules: [
        { name: "Sunday" },
        { name: "Monday" },
        { name: "Tuesday" },
        { name: "Wednesday" },
        { name: "Thursday" },
        { name: "Friday" },
        { name: "Saturday" },
      ],
      dialogForm: false,
      isLoadingBtn: false,
      isLoadingBtnDelete: false,
      formerror: {},
      modalUpdate: false,
      dt_headers: [
        {
          text: "ID",
          value: "id",
          name: "id",
          sortable: true,
          searchable: false,
          align: " d-none",
        },
        {
          text: "Winning combinations",
          value: "combinations",
          name: "combinations",
          sortable: false,
          searchable: true,
        },
        {
          text: "Draw",
          value: "name",
          name: "name",
          sortable: false,
          searchable: true,
        },
        // {
        //   text: "Area",
        //   value: "zone_name",
        //   name: "zone_name",
        //   sortable: false,
        //   searchable: true,
        // },
        {
          text: "Date",
          value: "date",
          name: "date",
          sortable: false,
          searchable: false,
        },
        // {
        //   text: "GM winners",
        //   value: "totalgmwinners",
        //   name: "totalgmwinners",
        //   sortable: false,
        //   searchable: false,
        // },
        {
          text: "Winners",
          value: "totalappwinners",
          name: "totalappwinners",
          sortable: false,
          searchable: false,
        },
      ],
      dt_options: {},
      dt_columns: {},
      dt_totalResult: 0,
      dt_searchInput: "",
      dt_searchQuery: "",
      dt_resultlist: [],
      dt_loading: true,
      dt_itemsPerPage: 50,
      dt_reload: "",
      dt_total_winnerprize: "",
      dt_filterDateFrom: "",
      form: new this.$Form({
        id: "",
        draw_id: "",
        combinations: "",
        date: "",
        issendsms: true,
        typewin: 0,
      }),
      draw_list: null,
      zone_list: null,
      region_list: [],
      filter: {
        region_id: null,
      },
      json_fields: {
      "Winning combinations": "combinations",
      "Draw": "name",
      // "Area": "zone_name",
      "Date": "date",
      // "GM winners": "totalgmwinners",
      "Winners": "totalappwinners",
    },
    };
  },
  methods: {
    
    schedule_draw_format(val) {
      // let data = [];
      // val = JSON.parse(val);
      // val.forEach(element => {
      //     data.push(element.name);
      // });
      // return data.join(', ');
    },
    modalForm() {
      this.modalUpdate = false;
      this.form.reset();
      this.dialogForm = true;
    },
    copyClipboard(data) {
      data = data.split(" / ");
    },
    async newData() {
      this.$Fire.$emit("overlay", true);
      this.isLoadingBtn = true;
      this.form
        .post(this.$_CONFIG.api("API_DAILYRESULTS"))
        .then(({ data }) => {
          this.isLoadingBtn = false;
          this.getDataFromApi();
          this.dialogForm = false;
          // this.$Swal.fire(
          //   "Success!",
          //   "Record has been successfully added.",
          //   "success"
          // );
          this.$toast.fire({
            icon: "success",
            title: "Record has been successfully added.",
          });
          this.$Fire.$emit("overlay", false);
        })
        .catch((error) => {
          this.isLoadingBtn = false;
          this.formerror = error.response.data.errors;
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
    async findData(data) {
      this.formerror = {};
      this.form.reset();
      this.form.fill(data);
      console.log(this.form);
      this.modalUpdate = true;
      this.dialogForm = true;
    },
    async updateData() {
      this.isLoadingBtn = true;
      this.form
        .put(this.$_CONFIG.api("API_DAILYRESULTS") + "/" + this.form.id)
        .then(() => {
          this.isLoadingBtn = false;
          this.dialogForm = false;
          this.getDataFromApi();
          this.$toast.fire({
            icon: "success",
            title: "Record has been successfully updated.",
          });
        })
        .catch((error) => {
          this.isLoadingBtn = false;
          this.formerror = error.response.data.errors;
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
    async deleteData(id) {
      this.isLoadingBtnDelete = true;
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to delete all record?"
        )
      ) {
        this.form
          .delete(this.$_CONFIG.api("API_DAILYRESULTS") + "/" + this.form.id)
          .then(() => {
            this.isLoadingBtnDelete = false;
            this.dialogForm = false;
            this.getDataFromApi();
            this.$toast.fire({
              icon: "success",
              title: "Record has been successfully deleted.",
            });
          })
          .catch(() => {
            this.isLoadingBtnDelete = false;
            this.$toast.fire({ icon: "error", title: "Something went wrong!" });
          });
      } else {
        this.isLoadingBtnDelete = false;
      }
    },
    paramsfilter() {
      return {
        ...this.dt_options,
        searchdata: this.dt_searchQuery,
        filterDate: this.dt_filterDateFrom,
        region_id: this.filter.region_id,
      };
    },
    async getDataFromApi() {
      this.dt_loading = true;
      var paramsfilter = await this.paramsfilter();
      this.dt_columns = await this.$YajraDT.setHeader(this.dt_headers);
      let params = await this.$YajraDT.params(
        paramsfilter,
        this.dt_options,
        this.dt_itemsPerPage,
        this.dt_columns
      );
      let apiPath = (await this.$_CONFIG.api("API_DAILYRESULTS")) + "search";

      await this.$axios
        .post(apiPath + "?" + this.$.param(params))
        .then((res) => {
          if (this.dt_totalResult != res.data.recordsFiltered) {
            this.dt_options.page = 1;
          }

          this.dt_resultlist = res.data.data;
          this.dt_totalResult = res.data.recordsFiltered;
          this.dt_loading = false;
        })
        .catch((err) => {
          this.dt_loading = false;
          console.log(err);
        });

      var unwatch = this.$watch(
        "dt_options.page",
        function(newValue, oldValue) {
          this.getDataFromApi();
          unwatch();
        },
        { deep: true }
      );
    },
    async drawlist() {
      let response = await this.$axios.get(this.$_CONFIG.api() + "/draw/list");
      this.draw_list = response.data;
    },
    async zonelist() {
      let response = await this.$axios.get(
        this.$_CONFIG.api() + "/allzonelist"
      );
      this.zone_list = response.data;
    },
    async regionlist() {
      let response = await this.$axios.get(
        this.$_CONFIG.api() + "/allregionlist"
      );
      this.region_list = response.data;
    },
    async exportData() {
      return this.dt_resultlist;
    },
  },
  created() {
    this.getDataFromApi();
    this.regionlist();
  },
  mounted() {
    this.drawlist();
    this.zonelist();
    this.regionlist();
  },
};
</script>
<style scoped></style>